/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MasteryCriteriaModel } from '../../models/mastery-criteria-model';

export interface GetMasteryCriteria$Params {
  patientID?: number;
}

export function GetMasteryCriteria(http: HttpClient, rootUrl: string, params?: GetMasteryCriteria$Params, context?: HttpContext): Observable<StrictHttpResponse<MasteryCriteriaModel>> {
  const rb = new RequestBuilder(rootUrl, GetMasteryCriteria.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MasteryCriteriaModel>;
    })
  );
}

GetMasteryCriteria.PATH = '/api/Supervisor/GetMasteryCriteria';
